import React, { Suspense, lazy } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import UpgradeModal from '@/components/billing/UpgradeModal'

/**
 * React Query DevTools — loaded lazily and only in development builds.
 *
 * In production, Vite statically analyses `import.meta.env.DEV` (which is
 * `false` at build time) and tree-shakes the entire dynamic import branch,
 * so the devtools are never included in the production bundle.
 */
const ReactQueryDevtools = import.meta.env.DEV
  ? lazy(() =>
      import('@tanstack/react-query-devtools').then((m) => ({
        default: () => <m.ReactQueryDevtools initialIsOpen={false} />,
      })),
    )
  : null

/**
 * AppLayout — the authenticated shell for all protected pages.
 *
 * Layout:
 *   ┌─────────────────────────────────────────────┐
 *   │  Sidebar (240 px)        │  Page content    │
 *   │                          │  <Outlet />       │
 *   └─────────────────────────────────────────────┘
 *
 * `overflow-hidden` on the outer shell with `overflow-y-auto` on main ensures
 * the sidebar stays full-height while page content scrolls independently.
 *
 * UpgradeModal is mounted here (once) so it is always available from any page
 * via the `useUpgradeStore` Zustand store.
 */
export default function AppLayout() {
  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar />
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
      {ReactQueryDevtools && (
        <Suspense fallback={null}>
          <ReactQueryDevtools />
        </Suspense>
      )}
      {/* Global upgrade modal — controlled by useUpgradeStore */}
      <UpgradeModal />
    </div>
  )
}
